





















import { InformationCircleIcon } from '@vue-hero-icons/outline';
import { computed, defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'FormBlock',
    components: { InformationCircleIcon },
    props: {
        title: {
            type: String,
            required: false,
        },
        tooltip: {
            type: String,
            required: false,
        },
    },
    setup(props, { slots }) {
        const isEmpty = computed(() => !slots.default);

        return { isEmpty };
    },
});
